export const taxasLabels = [
  {
    label: "afrmm",
    selectName: "afrmm_tax_type",
    inputName: "afrmm_tax",
    bySelectName: "afrmm_tax_from",
    options: [
      { label: "Carga", value: "ORDERLOAD" },
      { label: "Frete Marítimo", value: "FRETEMARITIMO" },
      { label: "Contêiner", value: "CONTAINER" },
    ],
  },
  {
    label: "collect de frete",
    selectName: "freight_collect_tax_type",
    inputName: "freight_collect_tax",
    bySelectName: "freight_collect_tax_from",
    options: [
      { label: "Carga", value: "ORDERLOAD" },
      { label: "Frete Marítimo", value: "FRETEMARITIMO" },
      { label: "Contêiner", value: "CONTAINER" },
    ],
  },
  {
    label: "outras despesas de frete",
    selectName: "other_shipping_costs_tax_type",
    inputName: "other_shipping_costs_tax",
    bySelectName: "other_shipping_costs_tax_from",
    options: [
      { label: "Carga", value: "ORDERLOAD" },
      { label: "Frete Marítimo", value: "FRETEMARITIMO" },
      { label: "Contêiner", value: "CONTAINER" },
    ],
  },
  {
    label: "Armazenagem",
    selectName: "storage_tax_type", //criar no model
    inputName: "storage_tax",
    bySelectName: "storage_tax_from",
    options: [
      { label: "Carga", value: "ORDERLOAD" },
      { label: "Frete Marítimo", value: "FRETEMARITIMO" },
      { label: "Contêiner", value: "CONTAINER" },
    ],
  },
  {
    label: "Desembaraço Aduaneiro",
    selectName: "customs_clearance_type",
    inputName: "customs_clearance",
    bySelectName: "customs_clearance_from",
    options: [
      { label: "Carga", value: "ORDERLOAD" },
      { label: "Frete Marítimo", value: "FRETEMARITIMO" },
      { label: "Contêiner", value: "CONTAINER" },
    ],
  },
  {
    label: "Outras Despesas",
    selectName: "other_expenses_type",
    inputName: "other_expenses_tax",
    bySelectName: "other_expenses_from",
    options: [
      { label: "Carga", value: "ORDERLOAD" },
      { label: "Frete Marítimo", value: "FRETEMARITIMO" },
      { label: "Contêiner", value: "CONTAINER" },
    ],
  },
];
